/**
 * @Description 评分
 * 注意该部分代码和点位测评详情对应部分是公共使用的，修改时一定要注意！！！
 */

import { FC, useMemo, } from 'react';
import { Col, Row } from 'antd';
import ScoreSummary from './components/ScoreSummary';
import ScoreSummaryHorizontal from './components/ScoreSummaryHorizontal';
import ScoreCard from './components/ScoreCard';
import FiveDimensional from '@/common/components/business/SiteMap/FiveDimensional';
import ImageLine from './components/ImageLine';
import { isNotEmpty } from '@lhb/func';
import { markTypeEnum } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import styles from './index.module.less';
import cs from 'classnames';
import PredictSale from './components/PredictSale';
import ScoreExplaimIcon from '@/common/components/business/AreaScoreWithoutSum/ScoreExplaimIcon';
import FourNoSumCon from './components/FourNoSumCon';

const Evaluation: FC<any> = ({
  overView,
  picList,
  configSwitch,
  shareParams = {},
  // siteselectionmapb-选址地图；spotevaluation-点位测评
  provideFor = 'siteselectionmapb',
}) => {
  const showTotalScore = useMemo(() => overView?.showTotalScore, [overView]);
  const cardView = useMemo(() => overView?.scores || [], [overView]);

  const isFiveDimen = useMemo(() => {
    return markTypeEnum.five === overView?.markType;
  }, [overView]);

  const isSixDimen = useMemo(() => {
    return markTypeEnum.six === overView?.markType;
  }, [overView]);

  const predictSale = useMemo(() => {
    const {
      salesAmountPredict, // 预测营业额
      lowSalesAmountPredict,
      upSalesAmountPredict,
    } = overView || {};

    // 优先展示区间，无区间值时展示具体值
    const canShowRange = isNotEmpty(lowSalesAmountPredict) && isNotEmpty(upSalesAmountPredict);
    const canShowValue = isNotEmpty(salesAmountPredict);

    return canShowRange || canShowValue;
  }, [overView]);

  /**
   * @description 四维展示
   */
  const renderFourDimen = () => {
    return (
      <div className={styles.fourDimenCon}>
        <ScoreSummaryHorizontal
          overviewData={overView}
          predictSale={predictSale}
          configSwitch={configSwitch}
          shareParams={shareParams}
        />
        <div className={styles.allScoreCon}>
          <Row gutter={[24, 8]}>
            {cardView.length ? cardView.map((item) => (
              <Col span={12} key={item?.name}>
                <ScoreCard
                  title={item?.name}
                  totalScore={item?.score}
                  describe={item?.msg}
                  lineColor='#5B9FFF'
                />
              </Col>
            )) : <></>}
          </Row>
        </div>
      </div>
    );
  };

  /**
   * @description 四维无总分展示
   */
  const renderFourNoSumDimen = () => {
    return (
      <FourNoSumCon overViewData={overView} predictSale={predictSale} cardView={cardView}/>
    );
  };

  /**
   * @description 五维/六维展示
   */
  const renderFiveSixDimen = () => {
    return (
      <div className={styles.fiveSixeDimenCon}>
        <div className={styles.halfWidth}>
          <ScoreSummary
            overviewData={overView}
            predictSale={predictSale}
            configSwitch={configSwitch}
            shareParams={shareParams}
          />
        </div>
        <div className={styles.halfWidth}>
          <div className={cs(styles.fiveDimensionChartWrapper, isFiveDimen && styles.fiveDimen, isSixDimen && styles.sixDimen)}>
            <FiveDimensional
              indicator={overView?.scores?.map((item) => ({
                ...item,
                value: item?.score || 0,
                max: 100
              }))}
              seriesDataValue={overView?.scores?.map((item) => item.score || 0)}
              height={isFiveDimen ? 174 : 180}
              radarRadius={isFiveDimen ? '51%' : '50%'}
              valueFontSize={12}
              backgroundColor='#ffffff'
            />
          </div>
        </div>

      </div>
    );
  };

  /**
   * @description 五维/六维无总分展示
   */
  const renderFiveSixNoSumDimen = () => {
    // https://staticres.linhuiba.com/project-custom/locationpc/selectionmap/icon_turnover@3x.png
    return (
      <Row className={styles.fiveSixNoSumCon}>
        <Col span={predictSale ? 16 : 24}>
          <div className={styles.fiveSixNoSumChartWrapper}>
            <div className={styles.scoreTitle}>
              {isFiveDimen ? '五' : '六'}维评分
              <ScoreExplaimIcon
                data={overView}
                predictSale={predictSale}
                className={styles.titleIcon}/>
            </div>
            <FiveDimensional
              indicator={overView?.scores?.map((item) => ({
                ...item,
                value: item?.score || 0,
                max: 100
              }))}
              seriesDataValue={overView?.scores?.map((item) => item.score || 0)}
              height={180}
              radarRadius={isFiveDimen ? '51%' : '50%'}
              valueFontSize={12}
              backgroundColor='#F9FBFF'
              theme='blue'
            />
          </div>
        </Col>
        {predictSale ? <Col span={8}>
          <PredictSale overviewData={overView}/>
        </Col> : <></>}
      </Row>
    );
  };

  return (
    <div className={styles.evaluation}>
      {/* 四维一种布局，五维六维另一种布局,点位测评不需要区分是否展示总分 */}
      {showTotalScore || provideFor === 'spotevaluation'
        ? (isFiveDimen || isSixDimen ? renderFiveSixDimen() : renderFourDimen())
        : (isFiveDimen || isSixDimen ? renderFiveSixNoSumDimen() : renderFourNoSumDimen())}
      {/* 图片展示区域 */}
      {picList?.length ? <ImageLine values={picList} /> : ''}
    </div>
  );
};

export default Evaluation;
